import LoyaltyReceipt from './loyalty-receipt.vue';

export default LoyaltyReceipt;
